import React from 'react'
import styled from 'styled-components'
import kykiske from '../../Images/Thumbnails/kykiske.jpg'
import meowscarada from '../../Images/Thumbnails/meowscarada.jpg'



export default function Bio() {
    return (
        <Container>  
            <Image src={kykiske} alt="kykiske"/> 
            <Image src={meowscarada} alt="meowscarada"/> 
        </Container>
    )
}

const Container = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
gap: 1.5rem;
@media only screen and (min-width: 600px) {
    margin-left:20%;
    margin-right:20%;
`

const Image = styled.img`
  width: 100%;
  height: auto;
//   max-width:250px;
  object-fit: cover;
`